import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {
  alabaster,
  denim,
  grayscale,
  onyx,
  onyxLighter,
  white,
} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    backgroundColor: white,
    marginBottom: indent,
    paddingVertical: indent * 0.5,
    borderRadius: 8,
    overflow: 'visible' as const,
  },
  infoIcon: {
    color: grayscale,
  },
  header: {
    flexDirection: 'row',
    marginTop: indent * 0.7,
    marginBottom: indent,
    marginLeft: indent,
    marginRight: indent,
    justifyContent: 'space-between',
  },
  headerText: {
    color: onyxLighter,
    flex: 1,
  },
  PixelMargin: {
    marginRight: 1,
  },
  infoButtonFocusRing: {
    borderWidth: 0,
    borderColor: 'transparent',
  },
  listItem: {
    display: 'flex',
    flexDirection: 'row',
    paddingVertical: indent * 0.675,
    justifyContent: 'space-between',
  },
  listItemBorder: {
    borderRadius: 8,
    backgroundColor: alabaster,
    marginBottom: indent * 0.4,
    paddingLeft: indent,
    paddingRight: indent,
  },
  listItemLabel: {
    flexShrink: 1,
    flexGrow: 1,
    color: onyx,
    marginRight: indent * 0.4,
  },
  arrowIcon: {
    color: 'onyxLight',
    fontSize: 18,
    paddingLeft: indent * 0.675,
    alignSelf: 'center',
  },
  metricContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'baseline',
  },
  labelContainer: {
    flexDirection: 'row',
    flex: 1,
    alignItems: 'center',
  },
  newLabel: {
    color: denim,
    borderColor: denim,
    borderRadius: 11,
    borderWidth: 1,
    paddingHorizontal: 8,
    paddingVertical: 2,
    fontWeight: '700',
    marginRight: indent,
  },
  readonly: {
    paddingRight: indent * 0.25,
  },
});
